import { BUTTONS_SPACING_OPTIONS } from 'hb-react/backoffice/types/builder/itemAttributes/wrapperItemAttributes';

export const spacingSize = {
  [BUTTONS_SPACING_OPTIONS.SMALL]: 8,
  [BUTTONS_SPACING_OPTIONS.MEDIUM]: 12,
  [BUTTONS_SPACING_OPTIONS.LARGE]: 24,
};

export const DEFAULT_SPACING_SIZE = BUTTONS_SPACING_OPTIONS.MEDIUM;
